import { Box } from "@mui/material";
import { StepperProvider } from "../../context/stepper-provider";
import { DataCleaningProvider } from "./context/data-cleaning-context";
import StepperContent from "./stepper-content";
import { DATA_CLEANING_STEPS, LAYOUT } from "./constants";

const DataCleaning = () => {
  return (
    <StepperProvider steps={DATA_CLEANING_STEPS} initialStep={0}>
      <DataCleaningProvider>
        <Box
          sx={{ mx: "auto", p: LAYOUT.CONTAINER_PADDING }}
          data-testid="data-cleaning-container"
        >
          <StepperContent />
        </Box>
      </DataCleaningProvider>
    </StepperProvider>
  );
};

export default DataCleaning;
